module.exports = __webpack_require__.p + "8a0ce57f7d229e60ab979a392fa45e68.jpg";